import { useTranslation } from 'next-i18next';
import { usePublicMetaFilter } from '@/module/public/hooks/usePublicMetaFilter';
import { OfficialQuizIcon } from '@/module/public/icons/OfficialQuizIcon';
import { Checkbox } from '@/ui';
import { Label } from '@/ui/components/label';
import { FilterMenuItem } from './AsideFilter';
export const OfficialPublicQuiz = () => {
  const {
    checkedOfficialQuiz,
    handleToggleIsPublicQuiz
  } = usePublicMetaFilter();
  const {
    t
  } = useTranslation(['common']);
  return <FilterMenuItem className={'border-b border-b-alternative py-md'} onClick={e => {
    handleToggleIsPublicQuiz(!checkedOfficialQuiz);
    e.preventDefault();
  }} data-sentry-element="FilterMenuItem" data-sentry-component="OfficialPublicQuiz" data-sentry-source-file="OfficialPublicQuiz.tsx">
      <Label className={'flex size-full cursor-pointer items-center justify-start gap-3xs '} htmlFor={'public-quiz'} data-sentry-element="Label" data-sentry-source-file="OfficialPublicQuiz.tsx">
        <div className={'flex items-center gap-xs'}>
          <Checkbox checked={checkedOfficialQuiz} onCheckedChange={handleToggleIsPublicQuiz} id={'public-quiz'} data-sentry-element="Checkbox" data-sentry-source-file="OfficialPublicQuiz.tsx" />
          <span className={'text-body-md-semibold'}>
            {t('common.onlyOfficialQuiz')}
          </span>
        </div>
        <OfficialQuizIcon size={'sm'} data-sentry-element="OfficialQuizIcon" data-sentry-source-file="OfficialPublicQuiz.tsx" />
      </Label>
    </FilterMenuItem>;
};